import { createActions } from 'redux-actions';
import keyMirror from 'key-mirror';

export const constants = keyMirror({
    GET_PROFILE_REQUEST: null,
    GET_PROFILE_SUCCESS: null,
    GET_PROFILE_FAILURE: null,

    PROFILE_UPDATE_REQUEST: null,
    PROFILE_UPDATE_SUCCESS: null,
    PROFILE_UPDATE_FAILURE: null,

    ADD_USERS_CSV_REQUEST: null,
    ADD_USERS_CSV_SUCCESS: null,
    ADD_USERS_CSV_FAILURE: null,

    INVITE_USERS_REQUEST: null,
    INVITE_USERS_SUCCESS: null,
    INVITE_USERS_FAILURE: null,
});

export const {
    getProfileRequest,
    getProfileSuccess,
    getProfileFailure
} = createActions(
    constants.GET_PROFILE_REQUEST,
    constants.GET_PROFILE_SUCCESS,
    constants.GET_PROFILE_FAILURE
);

export const {
    profileUpdateRequest,
    profileUpdateSuccess,
    profileUpdateFailure
} = createActions(
    constants.PROFILE_UPDATE_REQUEST,
    constants.PROFILE_UPDATE_SUCCESS,
    constants.PROFILE_UPDATE_FAILURE
);

export const {
    addUsersCsvRequest,
    addUsersCsvSuccess,
    addUsersCsvFailure
} = createActions(
    constants.ADD_USERS_CSV_REQUEST,
    constants.ADD_USERS_CSV_SUCCESS,
    constants.ADD_USERS_CSV_FAILURE
);

export const {
    inviteUsersRequest,
    inviteUsersSuccess,
    inviteUsersFailure
} = createActions(
    constants.INVITE_USERS_REQUEST,
    constants.INVITE_USERS_SUCCESS,
    constants.INVITE_USERS_FAILURE
);



/** WEBPACK FOOTER **
 ** ./src/core/profile/profileActions.js
 **/